export enum InvoiceStatusesEnum {
  Draft = 0,
  Issued = 100,
  PendingPayment = 200,
  Paid = 300,
  Finalized = 400,
  Refunded = 999
}
